import React, { useRef, useState } from "react";
import { Stack, TextField, MenuItem, Button } from "@mui/material";
import ImagePickerDialog from "../ImagePickerDialog";
import { insertAtCursor } from "../helpers/insertAtCursor";

const QuestionFormOnlyText = ({ value, onChange }) => {
    const v = value || {};

    const [pickerOpen, setPickerOpen] = useState(false);
    const textInputRef = useRef(null);

    const onPickImage = (img) => {
        const caption = img.originalFilename || "Зображення";

        const block =
            `\n<figure>` +
            `\n  <img src="${img.url}" alt="${caption}" style="width:100%;" />` +
            `\n  <figcaption class="imgcaption">${caption}</figcaption>` +
            `\n</figure>\n`;

        const nextText = insertAtCursor(textInputRef.current, v.text || "", block);
        onChange({ ...v, text: nextText });
        setPickerOpen(false);
    };

    return (
        <Stack spacing={2}>
            <TextField label="Тип завдання" value={"text"} fullWidth select disabled helperText="Презентаційний блок без перевірки відповіді.">
                <MenuItem value="text">Текст / презентація</MenuItem>
            </TextField>

            <TextField
                label="Підзаголовок"
                value={v.subtitle || ""}
                onChange={(e) => onChange({ ...v, subtitle: e.target.value })}
                helperText="Необов'язково. Показується під назвою модуля."
                fullWidth
            />

            <Stack direction="row" spacing={1}>
                <Button variant="outlined" onClick={() => setPickerOpen(true)}>
                    Вставити зображення
                </Button>
            </Stack>

            <TextField
                label="Текст (HTML)"
                value={v.text || ""}
                onChange={(e) => onChange({ ...v, text: e.target.value })}
                helperText="Основний контент блоку. Можна використовувати HTML."
                fullWidth
                multiline
                minRows={10}
                inputRef={textInputRef}
            />

            <ImagePickerDialog
                open={pickerOpen}
                onClose={() => setPickerOpen(false)}
                onPick={onPickImage}
            />
        </Stack>
    );
};

export default QuestionFormOnlyText;
